import { BasicLayout } from '../../../components/BasicLayout';
import NewPasswordSet from './NewPasswordSet';

const NewPasswordSetScene = () => {
  return (
    <BasicLayout>
      <NewPasswordSet />
    </BasicLayout>
  );
};

export default NewPasswordSetScene;
